/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Handover_QuestionInputs */

const en_faq_handover_question = /** @type {(inputs: Faq_Handover_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What do we receive at handover?`)
};

const lv_faq_handover_question = /** @type {(inputs: Faq_Handover_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ko saņemam nodošanas brīdī?`)
};

/**
* | output |
* | --- |
* | "What do we receive at handover?" |
*
* @param {Faq_Handover_QuestionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_handover_question = /** @type {((inputs?: Faq_Handover_QuestionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Handover_QuestionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_handover_question(inputs)
	return en_faq_handover_question(inputs)
});